import {ChangeEvent, forwardRef} from 'react';
import styled from 'styled-components';
import {Button} from '@/components/Button';
import {ToggleSwitch} from '@/components/ToggleSwitch';
import {Typography} from '@/components/Typography';
import {Flexbox, FlexFullGrow} from '@/styled-components';
import {getHexWithOpacity, palette} from '@/styles';
import {DataboxProps, DataSelectBox} from './DataSelectBox';

interface IProps extends DataboxProps {
  title: string;
  active: boolean;
  onSwitchChanged(value: boolean): void;
}

export const SelectInfoWindow = forwardRef<HTMLDivElement, IProps>(
  (
    {
      options,
      title,
      active,
      selected,
      limit,
      onSelected,
      onSwitchChanged,
      ...props
    },
    ref
  ) => {
    const onClear = () => {
      onSelected([]);
    };

    const handleSwitch = (e: ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;

      onSwitchChanged(!!checked);
    };

    return (
      <Root ref={ref}>
        <Box>
          <Typography variant="medium12" fontWeight="700">
            {title} ({selected.length}/{limit})
          </Typography>
          <FlexFullGrow />
          <ToggleSwitch
            variant="small"
            checked={active}
            onChange={handleSwitch}
          />
        </Box>
        <Body>
          <DataSelectBox
            options={options}
            selected={selected}
            limit={limit}
            onSelected={onSelected}
            {...props}
          />
        </Body>
        <Box>
          <FlexFullGrow />
          <Button
            variant="outline"
            color="black"
            size="small"
            onClick={onClear}
          >
            전체 선택 해제
          </Button>
        </Box>
      </Root>
    );
  }
);

const Root = styled.div`
  position: absolute;
  width: 220px;
  right: 100%;
  top: 0;
  margin-right: 16px;
  background-color: ${palette.white};
  border: 1px solid ${getHexWithOpacity(palette.black, 0.3)};
  border-radius: 10px;
`;

const Body = styled.div`
  padding: 0 7px 8px 7px;
`;

const Box = styled(Flexbox)`
  padding: 8px;
`;
